import { render, staticRenderFns } from "./ClaimDetailManagement.vue?vue&type=template&id=3deefe34"
import script from "./ClaimDetailManagement.vue?vue&type=script&lang=js"
export * from "./ClaimDetailManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports